import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import ProviderSearch from '@/website/components/ProviderSearch.tsx';

const HeroSection: React.FC = () => {
  return (
    <section className="bg-light py-5">
      <Container>
        <Row className="align-items-center">
          <Col md={7} className="text-center text-md-start">
            <h1 className="display-6 fw-bold">
              Dietitians who accept your Insurance
            </h1>
            <p className="fs-5 lead text-muted mb-3">
              Collaborate with a qualified dietitian who will create a tailored
              plan for you.
            </p>
            <div className="mb-1">
              <ProviderSearch />
            </div>
            <p className="fs-5 mt-1 mb-0 text-info-emphasis">
              <strong>Great news!</strong> Most of our patients pay{' '}
              <strong>$0</strong> out of pocket.
            </p>
          </Col>
          <Col md={5} className="text-center">
            <img
              src="/images/hero-dietitian.webp"
              alt="Smiling dietitian"
              className="img-fluid"
            />
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default HeroSection;
